import moment from "moment";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.locale("ko");
dayjs.extend(localizedFormat);

type DateFormatOptions = {
  withTime?: boolean; // 시간 표시 여부
  separator?: "dot" | "dash"; // 구분자 옵션 추가
};

export const getRangeMoment = (
  startDate: string,
  endDate: string,
  type: "years" | "months" | "days" | "hours",
) => {
  const fromDate = moment(startDate);
  const toDate = moment(endDate);
  const diff = toDate.diff(fromDate, type);
  const range: moment.Moment[] = [];
  for (let i = 0; i < diff; i++) {
    range.push(moment(startDate).add(i, type));
  }
  return range;
};

/**
 * 날짜 문자열을 지정된 형식으로 변환
 * @param dateString - ISO 형식의 날짜 문자열 (예: "2024-11-18T16:00:00.000Z")
 * @param options - 포맷 옵션
 * @example
 * formatSimpleDate("2024-11-18T16:00:00.000Z") // "2024. 11. 18"
 * formatSimpleDate("2024-11-18T16:00:00.000Z", { separator: 'dash' }) // "2024-11-18"
 * formatSimpleDate("2024-11-18T16:00:00.000Z", { withTime: true, separator: 'dot' }) // "2024. 11. 18. 16:00"
 */
export const formatSimpleDate = (
  dateString: string,
  options: DateFormatOptions = {},
) => {
  const { withTime = false, separator = "dot" } = options;
  const m = moment(dateString);

  if (!m.isValid()) {
    return "";
  }

  const dateFormat = separator === "dot" ? "YYYY. MM. DD" : "YYYY-MM-DD";

  if (withTime) {
    return m.format(`${dateFormat}${separator === "dot" ? "." : ""} HH:mm`);
  }

  return m.format(dateFormat);
};

export const formatDateToKo = (dateString: string): string => {
  return dayjs(dateString).format("YYYY년 MM월 DD일(dd)");
};

export const formatTime = (start: string, end: string): string => {
  return `${dayjs(start).format("HH:mm")} - ${dayjs(end).format("HH:mm")}`;
};
